<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<div mat-dialog-title>Print Report</div>
<form #printForm="ngForm" (ngSubmit)="print()" cdkTrapFocus>
  <mat-dialog-content fxLayout="column">
    <div fxLayout="column">
      <mat-checkbox name="showTitle"
        [ngModel]="showTitle$ | async"
      (ngModelChange)="setShowTitle($event)">Show Title?</mat-checkbox>
      <mat-form-field>
        <input type="text" matInput
          name="titleText"
          #titleText="ngModel"
          placeholder="Title:"
          [required]="showTitle$ | async"
          [ngModel]="titleText$ | async"
          (ngModelChange)="setTitleText($event)"/>
        @if (titleText.invalid) {
          <mat-error>Title is required if Show Title is checked.</mat-error>
        }
      </mat-form-field>
      <mat-checkbox [ngModel]="showLegend$ | async" name="showLegend"
      (ngModelChange)="setShowLegend($event)">Show Legend</mat-checkbox>
      <mat-checkbox [ngModel]="showNorth$ | async" name="showNorth"
      (ngModelChange)="setShowNorth($event)">Show North Arrow</mat-checkbox>
      <mat-form-field>
        <mat-select placeholder="Paper Size:"
          name="paperSize" #paperSize="ngModel"
          [ngModel]="paperSize$ | async"
          (ngModelChange)="setPaperSize($event)"
          [required]="true"
          [compareWith]="paperCompareFn">
          @for (paperType of paperOptions; track paperType) {
            <mat-option [value]="paperType">
              {{ paperType.label }}
            </mat-option>
          }
        </mat-select>
        @if (paperSize.invalid) {
          <mat-error>Please select a paper size</mat-error>
        }
      </mat-form-field>
    </div>
    <mat-progress-bar [ngClass]="{'hide-progress': !printing}" mode="determinate"
    [value]="progress$ | async"></mat-progress-bar>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button mat-button type="submit"
    [disabled]="printing || !printForm.form.valid">Print</button>
  </mat-dialog-actions>
</form>
